import { useState, type FormEvent } from "react";
import { useOnboardingForm } from "../useOnboardingForm";
import { StepHeading, StepShell } from "@codel/dova-ds";
import { TextField } from "../../components/TextField";
import { Button } from "../components/Button";
import type { StepProps } from "../flowConfig";
import { FREE_TEXT_QUESTION } from "../answerVocabulary";

export function S5bVision({ onNext, onBack, currentStepIndex, totalSteps }: StepProps) {
  const { state, updateAnswers } = useOnboardingForm();
  const [sixMonths, setSixMonths] = useState(state.answers.sixMonthsFromNow ?? "");

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    updateAnswers({
      sixMonthsFromNow: sixMonths.trim() === "" ? null : sixMonths.trim(),
    });
    onNext();
  };

  return (
    <StepShell
      showBack
      onBack={onBack}
      currentStep={currentStepIndex}
      totalSteps={totalSteps}
      onSubmit={handleSubmit}
      footer={<Button type="submit">Continue</Button>}
    >
      <StepHeading title={FREE_TEXT_QUESTION.six_months_from_now} />

      {/* The question is the HEADING now, so the label is hidden rather than deleted:
          the field still needs an accessible name, and repeating the question above it
          in 14px was the visible half of saying the same thing twice. */}
      <TextField multiline
        id="six-months"
        label={FREE_TEXT_QUESTION.six_months_from_now}
        labelHidden
        hint="Optional · 1–2 sentences"
        value={sixMonths}
        onChange={setSixMonths}
        rows={3}
        placeholder="I'd love for us to…"
      />
    </StepShell>
  );
}
